// src/utils/formatCurrency.ts

const DEFAULT_LOCALE = "nl-NL"
const DEFAULT_CURRENCY = "EUR"
/**
 * Generic currency formatter.
 * @param value - numeric amount
 * @param locale - BCP 47 locale (e.g. 'nl-NL', 'en-US')
 * @param currency - ISO 4217 code (e.g. 'EUR', 'USD')
 * @returns formatted currency string
 */
export function formatCurrency(value: number, locale: string = "nl-NL", currency: string = "EUR"): string {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
    }).format(value);
}

/**
 * Returns a { raw, formatted } formatter bound to the given locale/currency.
 */
export function createCurrencyFormatter(options?: {
    locale?: string;
    currency?: string;
}) {
    const {
        locale = DEFAULT_LOCALE,
        currency = DEFAULT_CURRENCY,
    } = options || {};

    return (value: number) => ({
        raw: value,
        formatted: new Intl.NumberFormat(locale, {
            style: "currency",
            currency,
        }).format(value),
    });
}